<template>
  <div class="contact-vendor-appraisal-detail form-group">
    <p>Have you arranged an appraisal with the vendor?</p>
    <div class="ut-flex ut-pb-12">
      <oa-button
        class="ut-m-0"
        :text="'Yes'"
        :btnClass="{ color: arrangedAppraisal === 1 ? 'green' : 'white' }"
        @click="arrangedAppraisal = 1"
      />
      <oa-button
        class="ut-ml-6"
        :text="'No, not yet'"
        :btnClass="{ color: arrangedAppraisal === 2 ? 'green' : 'white' }"
        @click="arrangedAppraisal = 2"
      />
    </div>

    <div v-show="arrangedAppraisal === 1" class="form-group">
      <label for="followup-date">Appraisal date</label>
      <oa-datepicker v-model="followupDate" />
      <p class="hint">Enter the appraisal time and date and we'll send you a reminder</p>
    </div>

    <label for="comments">Comments</label>
    <textarea
      id="comments"
      rows="5"
      v-model="comment"
    />

    <oa-button
      class="ut-mt-6"
      :text="'Confirm'"
      :btnClass="{ color: 'green' }"
      :disabled="disableSubmit || arrangedAppraisal === 0"
      @click="submitContactedDetails"
      v-gaEvent="gaEvent(`Leads Management - Click update lead submit - Contacted Appraisal Detail (${arrangedAppraisal === 1 ? 'appraisal arranged' : 'no appraisal'}) - Confirm`)"
    />
  </div>
</template>

<script>

import {
  mapState, mapActions, mapMutations,
} from 'vuex';
import { LeadAgentLeadStageType, LeadAgentLeadStageTypeId } from '@/Mapper/LeadAgentLeadStageType';
import OaDatepicker from '@/components/Forms/OaDatepicker';
import OaButton from '@/components/Forms/OaButton';
import StageUpdate from '@/mixins/StageUpdate';

export default {
  name: 'ContactVendorAppraisalDetail',
  mixins: [StageUpdate],
  components: {
    OaButton,
    OaDatepicker,
  },
  props: {
    contactedDetails: {
      default: null,
    },
  },
  computed: {
    ...mapState({
      agent: state => state.agentStore.agent,
      user: state => state.userStore.user,
      lam: state => state.leadAgentMappingStore.lam,
      lead: state => state.leadAgentMappingStore.lead,
    }),
  },
  data() {
    return {
      disableSubmit: false,
      arrangedAppraisal: this.contactedDetails ? this.contactedDetails.arrangedappraisalid : 0,
      followupDate: this.contactedDetails ? this.contactedDetails.arrangedappraisaldate : '',
      comment: this.contactedDetails ? this.contactedDetails.contacteddetail : '',
    };
  },
  mounted() {
    if (this.contactedDetails) {
      this.arrangedAppraisal = this.contactedDetails.arrangedappraisalid || 0;
      this.comment = this.contactedDetails.contacteddetail || '';
      this.followupDate = this.contactedDetails.arrangedappraisaldate || '';
    }
  },
  methods: {
    ...mapActions('leadAgentMappingStore', [
      'updateLeadAgentMapping',
    ]),
    ...mapMutations('leadAgentMappingStore', [
      'setLeadAgentMapping',
    ]),
    createCaseForContactedUpdate() {
      const caseData = {
        leadkey: this.lead.key,
        agentkey: this.$route.params.ak,
        // agentkey: this.agent.key,
        leadstatus: LeadAgentLeadStageTypeId[LeadAgentLeadStageType.Contacted_Vendor],
        comment: this.comment,
      };
      return this.$apiServices.oa.lead.createCaseForLeadUpdate(caseData);
    },
    submitContactedDetails() {
      this.disableSubmit = true;
      this.saveContactedDetails()
        .then((details) => {
          this.$emit('set-contacted-details', details);
          if (this.comment && this.comment.length > 0) {
            this.createCaseForContactedUpdate();
          }
          this.disableSubmit = false;
          this.emitRefreshOpenedSections();
        }).catch((err) => {
          console.log(err);
          this.disableSubmit = false;
        });
    },
    emitRefreshOpenedSections() {
      this.$emit('refresh-opened-sections');
    },
    saveContactedDetails() {
      const data = {
        leadagentmappingid: this.lam.id,
        oauserkey: !!this.user && !!this.user.key ? this.user.key : this.agent.userkey,
        agentcontactmethodtypeid: '', // Contacted method 1=phone, 2=email, 3=sms
        arrangedappraisalid: this.arrangedAppraisal,
        arrangedappraisaldate: this.followupDate !== ''
          ? this.$helpers.formatDateApi(this.followupDate)
          : '',
        contacteddetail: this.comment,
        sourcetypeid: this.isLamOwner ? 1 : 5,
      };
      return this.$apiServices.oa.leadAgent.saveContactedDetails(data);
    },
  },
};

</script>

<style lang="scss" scoped>

.btn {
  margin-bottom: 15px;
}

p {
  @apply ut-font-normal ut-text-lg ut-pb-3;
  line-height: 28px;
}

label {
  @apply ut-font-bold ut-text-sm ut-pb-3 ut-tracking-normal ut-pt-6;
  line-height: 24px;
}

.option-list {
  input {
    width: min-content;
  }
  .label {
    @apply ut-ml-6;
  }
}

.hint {
  @apply ut-text-sm ut-font-light ut-tracking-normal;
}

</style>
